import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=4904c941&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=4904c941&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904c941",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4904c941')) {
      api.createRecord('4904c941', component.options)
    } else {
      api.reload('4904c941', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=4904c941&scoped=true", function () {
      api.rerender('4904c941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/orderDetail.vue"
export default component.exports